import React, {
  FC,
  useEffect,
  useRef,
  useState,
  createRef,
  useMemo,
  useCallback,
} from "react";
import { Link, useHistory } from "react-router-dom";
import {
  Row,
  Col,
  Input,
  Button,
  message,
  TimePicker,
  Dropdown,
  Upload,
  Spin,
  Checkbox,
} from "antd";
import { useMediaQuery } from "react-responsive";
import { ReactSVG } from "react-svg";
import {
  CloseCircleOutlined,
  CloseOutlined,
  DownOutlined,
  MoreOutlined,
  PlusOutlined,
  SearchOutlined,
  SendOutlined,
  SmileOutlined,
  UploadOutlined,
  VideoCameraOutlined,
} from "@ant-design/icons";
import MessageItem from "./MessageItem";
import Loader from "react-loader-spinner";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import _, { get, set } from "lodash";
import { PopupModal } from "components/Modals";
import { useDispatch, useSelector } from "react-redux";
import { PageSettingsModal } from "components/Modals";
import GroupIcon from "assets/SVGs/GroupIcon";
import SettingsIcon from "assets/SVGs/SettingsIcon";
import FilterIcon from "assets/SVGs/FilterIcon";
import CompassIcon from "assets/SVGs/CompassIcon";
import { PAGE_TYPES } from "utils/PageTypes";
import "./MapPanel.scss";
import moment from "moment";
import { APPEND_ALL_USERS, GET_USER_BY_ID } from "reducers/authReducer";
import { PeopleModal } from "components/Modals";
import {
  getTwilioSaveRecordingSubscriptionTopic,
  getTwilioSaveVideoRecordingPublishTopic,
  getTwilioVideoEndSubscriptionTopic,
  getPageTypingSubscriptionTopic,
  getTwilioVideoJoinSubscriptionTopic,
  getTwilioVideoLeftSubscriptionTopic,
  disconnectPageRequestPublishTopic,
  connectPageRequestPublishTopic,
  getSearchMessageSubscriptionTopic,
  getCreateMessagePublishTopic,
  getModifyPageSubscriptionTopic,
  getMembersRemoveFromPagePublishTopic,
} from "hooks/MQTTConstants";
import AddEventModal from "components/Modals/AddEventModal";
import AddPayModal from "components/Modals/AddPayModal";
import IoTAlertModal from "components/Modals/IoTAlertModal";
import { UPLOAD_MEDIA } from "../../../reducers/authReducer";
import { useParams, useLocation } from "react-router-dom";

import { throttle } from "throttle-debounce";

import { CID, RID } from "../../../constants/localStoreKeys";
import {
  getRequestHeader,
  wrapRequestPayload,
  getMessageRequestPayload,
} from "../../../helpers/request/RequestPayload";
import useLocalStorageService from "../../../services/localStorage";

import ConfirmationModal from "components/Modals/ConfirmationModal";
import { RootState } from "reducers/rootReducer";
import {
  SocketTopics,
  MessageEventType,
  MessageTypes,
} from "../../../constants/enums";
import { generateUUID } from "utils/appUtil";
import { ENCRYPT_TOKEN } from "reducers/authReducer";
import { formatFileSize } from "utils/fileUtils";
import {
  formatDate,
  getAvatar,
  getFriendUserInfo,
  isScrollbarAtBottom,
  truncateString,
} from "utils/chatUtils";
import EmojiPicker from "emoji-picker-react";
import QuoteMessage from "./QuoteMessage";
import ForwardMessagePopup from "./ForwardMessagePopup";
import { pushNotification } from "utils/notifications";

const dragDrop = require("drag-drop");

const throttledRequest = throttle(3000, (requestFn, ...args) => {
  requestFn(...args);
});

const { TextArea } = Input;

const MessageOppositeUserStatus: FC<{ user: string }> = ({ user }) => (
  <div className="message-opposite-user-status">
    <label>{user} is typing </label>
    <Loader type="ThreeDots" color="#91A5C6" height={10} width={10} />
  </div>
);

const clientId: string = "60c83dcefe8cea1cd6699618";
let timeout: NodeJS.Timeout;
let scrollTimeout: NodeJS.Timeout;
let typingTimeout: NodeJS.Timeout;

/**
 * The browser's geolocation API hands back `{latitude, longitude}`, but every
 * consumer in this app — mapSagas included — reads `{lat, long}`. Uploads used
 * to store the raw shape, so media records carried coordinates nothing could
 * read and never surfaced on the global map.
 */
const toBeamCoordinates = (location?: CurrentLocation) => ({
  lat: location?.latitude || 0,
  long: location?.longitude || 0,
});

/**
 * Only createdAt is indexed on the message search, so those are the only sorts
 * that can be served. Severity and author need index fields that do not exist
 * yet, and are surfaced as disabled rather than quietly ignored.
 */
const SORT_FIELDS: Record<string, { field: string; order: string }> = {
  newest: { field: "@createdAt", order: "DESC" },
  oldest: { field: "@createdAt", order: "ASC" },
};

const MessagePanel: FC<{ socket: ISocket; params: DashboardParams }> = ({
  socket,
  params,
}) => {
  const { screens, setScreens } = params;
  const isMobileScreen = useMediaQuery({ query: "(max-width: 700px)" });
  const {
    messages,
    messageToSend,
    searchMessages,
    messageSort,
    currentMessage,
    NoMessageFound,
  } = useSelector((state: RootState) => state.message);
  const { users, allUsers } = useSelector((state: RootState) => state.auth);
  const { saveRecordingNotification } = useSelector(
    (state: RootState) => state.search
  );
  const { requestIds } = useSelector((state: RootState) => state.dashboard);
  const { fileToSend } = useSelector((state: RootState) => state.message);
  const messagesEndRef = useRef<null | HTMLDivElement>(null);
  const [messagesVisible, setMessageVisible] = useState<boolean>(false);

  const dispatch = useDispatch();

  const [popupDisplayed, setPopUpDisplayed] = useState(false);
  const [peoplePopupDisplayed, setPeoplePopupDisplayed] = useState(false);
  const [filterPopupDisplayed, setFilterPopUpDisplayed] = useState(false);
  const [uploadPopupDisplayed, setUploadPopUpDisplayed] = useState(false);
  const [settingsModalDisplayed, setSettingsModalDisplayed] = useState(false);
  const [selectedMessageType, setSelectedMessageType] = useState("push");
  const [confirmationDialog, setConfirmationDialog] = useState(false);
  const [text, setText] = useState("");
  const [editTitle, setEditTitle] = useState(false);
  const [currentLocation, setCurrentLocation] = useState<CurrentLocation>();
  const [pageGroups, setPageGroups] = useState([]);

  const [eventModalOpen, setEventModalOpen] = useState<any>({ visible: false });
  const [payModalOpen, setPayModalOpen] = useState<any>({ visible: false });
  const [alertModalOpen, setAlertModalOpen] = useState(false);
  const [selectedMessage, setSelectedMessage] = useState<any>({});

  const [accepting, setAccepting] = useState(false);
  const [rejecting, setRejecting] = useState(false);
  const [files, setFiles] = useState<any>();
  const [uploadProgress, setUploadProgress] = useState<any>({});
  const [stickyDate, setStickyDate] = useState("");
  const [unreadMessageCount, setUnreadMessageCount] = useState<any>();
  const [hideDownScrollbar, setHideDownScrollbar] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [emojiToggle, setEmojiToggle] = useState(false);
  const [isReplyEnable, setIsReplyEnable] = useState(false);
  const [selectedQuoteMessage, setSelectedQuoteMessage] =
    useState<MessageObj>();
  const textRef = useRef<string>("");
  const [isForwardMessagePopupOpen, setIsForwardMessagePopupOpen] =
    useState<boolean>();
  const [selectedForwardMessage, setSelectedForwardMessage] =
    useState<MessageObj>();
  const [isFilePreviewOpen, setIsFilePreviewOpen] = useState(false);
  const [showVideo, setShowVideo] = useState(true);
  const [isInputFocused, setIsInputFocused] = useState(false);
  const { search } = useLocation();

  const { readBy, pageTyping } = useSelector(
    (state: RootState) => state.search
  );

  const { pageConnection } = useSelector((state: RootState) => state.search);

  const { selectedItem } = useSelector((state: RootState) => state.search);
  const pageId = useSelector(
    (state: RootState) => state.search.selectedItem,
    (a, b) => {
      return a?.pageId === b?.pageId;
    }
  )?.pageId;

  const memberActive = useSelector(
    (state: RootState) => state.search.selectedItem,
    (a, b) => {
      return a?.memberActive === b?.memberActive;
    }
  )?.memberActive;

  const [title, setTitle] = useState(
    selectedItem?.persistent?.static?.metadata?.title
  );
  const { getLocalStorageItem } = useLocalStorageService();
  const [edit, setEdit] = useState<MessageObj>();
  const [typing, setTyping] = useState<string>("");
  const [aiAssistEnabled, setAiAssistEnabled] = useState(false);
  const [conversationId, setConversationId] = useState<string | null>(null);
  const [aiAssistThinking, setAiAssistThinking] = useState(false);
  const webhookInFlightRef = useRef<string | null>(null);
  const history = useHistory();
  const type =
    selectedItem &&
      selectedItem?.type &&
      selectedItem?.type === PAGE_TYPES.BROADCAST
      ? "orange"
      : undefined;
  const color = type && type === "orange" ? "#FF5F25" : "#508AFA";
  const openPopupModal = () => {
    setPopUpDisplayed(true);
  };

  const uploadFiles = () => {
    let _files = files;
    _files.map((item, index) => {
      let file = item.file;
      let form = new FormData();
      form.append("file", file);
      form.append(
        "info",
        JSON.stringify({
          pageId: selectedItem.pageId,
          userId: localStorage.getItem("RID"),
          location: currentLocation
            ? {
              coordinates: toBeamCoordinates(currentLocation),
              clbs: {
                tags: [
                  "type:media",
                  `org:${selectedItem?.persistent?.static?.iotAsset?.config?.configUserCudbServiceId}`,
                  `name:${file.name}`,
                ],
              },
            }
            : undefined,
        })
      );

      dispatch(
        UPLOAD_MEDIA({
          form,
          isBio: undefined,
          onProgress: (progress) => {
            setUploadProgress((prevProgress) => ({
              ...prevProgress,
              [file.name]: progress,
            }));
            if (progress == 100) {
              setTimeout(() => {
                let _index = files.findIndex((x) => x.name == file.name);
                files.splice(_index, 1);
                setFiles(files);
                setUploadProgress((prevProgress) => ({
                  ...prevProgress,
                  [file.name]: 0,
                }));
              }, 1000);
            }
          },
          onError: (error) => {
            pushNotification(
              `An error occurred while uploading file ${file.name}`,
              "error"
            );
          },
        })
      );
    });
  };

  const handleImageError = (e) => {
    e.target.src = "/images/files-icon/document.png";
  };

  useEffect(() => {
    getCurrentLocation();
    dragDrop("#dropTarget", {
      onDrop: (files, pos, fileList, directories) => {
        addFilesToList(files);
      },
    });
    const query = new URLSearchParams(search);
    if (query.get("disableVideo")) {
      setShowVideo(false);
    }
  }, []);

  useEffect(() => {
    if (socket.client && selectedItem?.memberActive) {
      const groups =
        selectedItem?.persistent?.static?.metadata?.members?.groups ?? {};
      setPageGroups(Object.keys(groups));
    }
    if (selectedItem?.nonpersistent?.static?.live?.connections) {
      let connectionsTypings = [];
      Object.keys(selectedItem?.nonpersistent?.static?.live?.connections).map(
        (connection) => {
          const timestamp =
            selectedItem?.nonpersistent?.static?.live?.connections[connection]
              ?.typingTimestamp || 0;

          if (
            connection !== localStorage.getItem("CID") &&
            selectedItem?.nonpersistent?.static?.live?.connections[connection]
              .isTyping &&
            new Date().getTime() - timestamp < 5000
          ) {
            connectionsTypings.push(connection);
          }
        }
      );
      let typingUsers = [];
      connectionsTypings.map((connection) => {
        let userId =
          selectedItem?.nonpersistent?.static?.live?.connections?.[connection]
            ?.userId;
        let findUser = allUsers?.find(
          (obj) => obj?.id?.toString() === userId?.toString()
        );
        let userName = findUser?.beamId || `user# ${userId}`;
        typingUsers.push(userName);
      });
      if (typingUsers.length > 0) {
        setTyping(`${typingUsers.join(", ")}`);
      } else {
        setTyping("");
      }
    }
    setTitle(selectedItem?.persistent?.static?.metadata?.title);
  }, [selectedItem]);

  const subscribeToConnection = () => {
    socket.subscribeToEvent(
      SocketTopics.SubscribePageTopics,
      getTwilioVideoJoinSubscriptionTopic()
    );
    socket.subscribeToEvent(
      SocketTopics.SubscribePageTopics,
      getTwilioVideoLeftSubscriptionTopic()
    );
    socket.subscribeToEvent(
      SocketTopics.SubscribePageTopics,
      getTwilioSaveRecordingSubscriptionTopic()
    );
    socket.subscribeToEvent(
      SocketTopics.SubscribePageTopics,
      getTwilioVideoEndSubscriptionTopic()
    );

    // TODO: move the path with proper Name to MQTTConstant file
    socket.subscribeToEvent(
      SocketTopics.SubscribePageTopics,
      `${process.env.REACT_APP_ECO_SYSTEM}/service/live/page/${selectedItem?.pageId
      }/bds/nonpersistent/static/metadata/connections/${localStorage.getItem(
        "CID"
      )}/groups/+`,
      (data) => {
        if (!data.status) {
          dispatch({
            type: "CLEAR_MESSAGE",
            payload: { pageId: selectedItem?.pageId },
          });
        }
      }
    );

    socket.subscribeToEvent(
      SocketTopics.SubscribePageTopics,
      getPageTypingSubscriptionTopic(selectedItem?.pageId)
    );

    // TODO: move the path with proper Name to MQTTConstant file
    socket.subscribeToEvent(
      SocketTopics.SubscribePageTopics,
      getSearchMessageSubscriptionTopic(selectedItem?.pageId)
    );

    // socket.publishToEvent(
    //   SocketTopics.PublishPageTopics,
    //   disconnectPageRequestPublishTopic(),
    //   wrapRequestPayload({
    //     ...getRequestHeader(getLocalStorageItem(CID), getLocalStorageItem(RID)),
    //     pageId: selectedItem?.pageId,
    //   }),
    //   (data: any) => {
    //     socket.publishToEvent(
    //       SocketTopics.PublishPageTopics,
    //       connectPageRequestPublishTopic(),
    //       wrapRequestPayload({
    //         ...getRequestHeader(
    //           getLocalStorageItem(CID),
    //           getLocalStorageItem(RID)
    //         ),
    //         pageId: selectedItem?.pageId,
    //       }),
    //       (data) => {
    //         if (!data.status) {
    //           console.log("Publish error: ", data.message);
    //         }
    //       }
    //     );
    //   }
    // );

    dispatch({
      type: "SET_CONNECTION",
      payload: { groups: [] },
    });

    getCurrentLocation();
  };

  useEffect(() => {
    if (pageId) {
      subscribeToConnection();
      setMessageVisible(false);
    }
  }, [pageId]);

  useEffect(() => {
    if (memberActive) {
      subscribeToConnection();
    }
  }, [memberActive]);

  const handleToggleClick = () => {
    setEmojiToggle(!emojiToggle);
  };

  const uploadCount = useRef(0);

  useEffect(() => {
    if (!currentMessage || !selectedItem?.pageId) return;
    if (currentMessage.pageId != selectedItem.pageId) return;
    if (currentMessage.senderId?.toString() !== localStorage.getItem("RID")) return;
    if (!currentMessage.data?.conversationId) return;
    if (currentMessage.data?.fromAssistant) return;

    const key = `${currentMessage.id}-${currentMessage.data.conversationId}`;
    if (webhookInFlightRef.current === key) return;
    webhookInFlightRef.current = key;
    setAiAssistThinking(true);

    const timeoutId = setTimeout(() => {
      fetch(`${process.env.REACT_APP_AI_ASSISTANT_API}/api/assistant/v1/chat`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          pageId: String(selectedItem.pageId)
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          const assistantText = data?.answer;
          // const convId = data?.conversation_id;
          // const ridePageId = data?.ridePageId;
          if (assistantText) {
            sendMessage(assistantText, "text", { fromAssistant: true });
          }
          // if (ridePageId) {
          //   setConversationId(null);
          //   // history.push(`/page/${ridePageId}`);
          //   // dispatch({ type: "SEARCH_PAGE", payload: { reset: true } });
          // }
        })
        .catch(() => {
          pushNotification("AI Assist request failed", "error", "TOP_CENTER", 3000);
        })
        .finally(() => {
          setAiAssistThinking(false);
          webhookInFlightRef.current = null;
        });
    }, 1000);

    return () => clearTimeout(timeoutId);
  }, [currentMessage, selectedItem?.pageId]);

  useEffect(() => {
    if (
      currentMessage?.pageId == selectedItem?.pageId &&
      localStorage.getItem("RID") !== currentMessage?.senderId?.toString() &&
      currentMessage &&
      !hideDownScrollbar
    ) {
      setUnreadMessageCount((unreadMessageCount || 0) + 1);
    } else {
      if (scrollTimeout) clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        scrollToBottom();
      }, 500);
    }
    //     if(currentMessage?.messageType === "media") {
    //       uploadCount.current++;
    //     }
    //     if(uploadCount.current === 4) {
    //       uploadCount.current = 0;
    //       const message = {
    //         "header": {
    //             "accessToken": "",
    //             "connectionId": "168386",
    //             "userId": "116796",
    //             "udid": "b41fc86c-e93f-4b3e-aaa2-71b5a6bb93ce"
    //         },
    //         "messages": [
    //             {
    //                 "message": {
    //                     "type": "text",
    //                     "attributes": {
    //                         "notify": false,
    //                         "body": "Analyzing the images..."
    //                     }
    //                 },
    //                 "connectionInfo": {
    //                     "connectionMessageId": generateUUID(),
    //                     "connectionId": "168386",
    //                     "pageId": selectedItem?.pageId,
    //                     "userId": "116796",
    //                     "createdAt": new Date().getTime(),
    //                     "originalCreatedAt": new Date().getTime(),
    //                     "refMessage": {
    //                         "referenceType": "refer",
    //                         "pageMessage": null
    //                     },
    //                     "notificationTypes": [
    //                         "push"
    //                     ]
    //                 }
    //             }
    //         ],
    //         "connectionId": "168386",
    //         "connectionPubTopic": `${process.env.REACT_APP_ECO_SYSTEM}/connection/${getLocalStorageItem(
    //           CID
    //         )}/page/${selectedItem?.pageId}/createMessage`
    //     };

    //     console.log('send new message', message);


    //     setTimeout(() => {
    //       socket.publishToEvent(
    //         SocketTopics.PublishPageTopics,
    //         `${process.env.REACT_APP_ECO_SYSTEM}/connection/${getLocalStorageItem(
    //           CID
    //         )}/page/${selectedItem?.pageId}/group/${"members"}`,
    //         wrapRequestPayload(message)
    //       );
    //     }, 1000);


    //     const newMessage = {
    //       "header": {
    //           "accessToken": "",
    //           "connectionId": "168386",
    //           "userId": "116796",
    //           "udid": "b41fc86c-e93f-4b3e-aaa2-71b5a6bb93ce"
    //       },
    //       "messages": [
    //           {
    //               "message": {
    //                   "type": "text",
    //                   "attributes": {
    //                       "notify": false,
    //                       "body": "Detected: Lab-grown elongated cushion apprx. 6.0 ct, D-F color, VS1-VS2 clarity, Super ideal cut, 18K white gold, French pave (approx. 16 x 0.018 ct); band width 2.7 mm"
    //                   }
    //               },
    //               "connectionInfo": {
    //                   "connectionMessageId": generateUUID(),
    //                   "connectionId": "168386",
    //                   "pageId": selectedItem?.pageId,
    //                   "userId": "116796",
    //                   "createdAt": new Date().getTime(),
    //                   "originalCreatedAt": new Date().getTime(),
    //                   "refMessage": {
    //                       "referenceType": "refer",
    //                       "pageMessage": null
    //                   },
    //                   "notificationTypes": [
    //                       "push"
    //                   ]
    //               }
    //           }
    //       ],
    //       "connectionId": "168386",
    //       "connectionPubTopic": `${process.env.REACT_APP_ECO_SYSTEM}/connection/${getLocalStorageItem(
    //         CID
    //       )}/page/${selectedItem?.pageId}/createMessage`
    //   };

    //   setTimeout(() => {
    //     socket.publishToEvent(
    //       SocketTopics.PublishPageTopics,
    //       `${process.env.REACT_APP_ECO_SYSTEM}/connection/${getLocalStorageItem(
    //         CID
    //       )}/page/${selectedItem?.pageId}/group/${"members"}`,
    //       wrapRequestPayload(newMessage)
    //     );
    //   }, 6000);

    //   const newMessage1 = {
    //     "header": {
    //         "accessToken": "",
    //         "connectionId": "168386",
    //         "userId": "116796",
    //         "udid": "b41fc86c-e93f-4b3e-aaa2-71b5a6bb93ce"
    //     },
    //     "messages": [
    //         {
    //             "message": {
    //                 "type": "text",
    //                 "attributes": {
    //                     "notify": false,
    //                     "body": "Generating BOM and price"
    //                 }
    //             },
    //             "connectionInfo": {
    //                 "connectionMessageId": generateUUID(),
    //                 "connectionId": "168386",
    //                 "pageId": selectedItem?.pageId,
    //                 "userId": "116796",
    //                 "createdAt": new Date().getTime(),
    //                 "originalCreatedAt": new Date().getTime(),
    //                 "refMessage": {
    //                     "referenceType": "refer",
    //                     "pageMessage": null
    //                 },
    //                 "notificationTypes": [
    //                     "push"
    //                 ]
    //             }
    //         }
    //     ],
    //     "connectionId": "168386",
    //     "connectionPubTopic": `${process.env.REACT_APP_ECO_SYSTEM}/connection/${getLocalStorageItem(
    //       CID
    //     )}/page/${selectedItem?.pageId}/createMessage`
    // };

    // setTimeout(() => {
    //   socket.publishToEvent(
    //     SocketTopics.PublishPageTopics,
    //     `${process.env.REACT_APP_ECO_SYSTEM}/connection/${getLocalStorageItem(
    //       CID
    //     )}/page/${selectedItem?.pageId}/group/${"members"}`,
    //     wrapRequestPayload(newMessage1)
    //   );
    // }, 7000);


    //     }

    //     if(currentMessage?.messageType === "rsvp-response"){
    //       if(currentMessage?.data?.body?.includes("Accept")){
    //         const newMessage4 = {
    //           "header": {
    //               "accessToken": "",
    //               "connectionId": "168386",
    //               "userId": "116796",
    //               "udid": "3a9b536f-aac9-47d8-93e1-a7c344f61e02"
    //           },
    //           "messages": [
    //               {
    //                   "message": {
    //                       "type": "rsvp",
    //                       "attributes": {
    //                           "type": "threeButtons",
    //                           "options": {
    //                               "option1": "Reserve",
    //                               "option2": "Pay now",
    //                               "option3": "No"
    //                           },
    //                           "rsvpTitle": "Ready to reserve the stone or pay now?",
    //                           "body": "Ready to reserve the stone or pay now?"
    //                       }
    //                   },
    //                   "connectionInfo": {
    //                       "connectionMessageId": generateUUID(),
    //                       "connectionId": "168386",
    //                       "pageId": selectedItem?.pageId,
    //                       "userId": "116796",
    //                       "createdAt": new Date().getTime(),
    //                       "originalCreatedAt": new Date().getTime(),
    //                       "refMessage": {
    //                           "referenceType": "refer",
    //                           "pageMessage": null
    //                       },
    //                       "notificationTypes": [
    //                           "push"
    //                       ]
    //                   }
    //               }
    //           ],
    //           "connectionId": "168386",
    //           "connectionPubTopic": `${process.env.REACT_APP_ECO_SYSTEM}/connection/${getLocalStorageItem(
    //             CID
    //           )}/page/${selectedItem?.pageId}/createMessage`
    //       };

    //       setTimeout(() => {
    //         socket.publishToEvent(
    //           SocketTopics.PublishPageTopics,
    //           `${process.env.REACT_APP_ECO_SYSTEM}/connection/${getLocalStorageItem(
    //             CID
    //           )}/page/${selectedItem?.pageId}/group/${"members"}`,
    //           wrapRequestPayload(newMessage4)
    //         );
    //       }, 2000);
    //       }

    //       if(currentMessage?.data?.body?.includes("Reserve")){
    //         const newMessage4 = {
    //           "header": {
    //               "accessToken": "",
    //               "connectionId": "168386",
    //               "userId": "116796",
    //               "udid": "3a9b536f-aac9-47d8-93e1-a7c344f61e02"
    //           },
    //           "messages": [
    //               {
    //                   "message": {
    //                       "type": "text",
    //                     "attributes": {
    //                         "notify": false,
    //                         "body": "Reservation placed. You will receive confirmation in this chat. Lead time is 2-3 weeks. Have a nice day!"
    //                     }
    //                   },
    //                   "connectionInfo": {
    //                       "connectionMessageId": generateUUID(),
    //                       "connectionId": "168386",
    //                       "pageId": selectedItem?.pageId,
    //                       "userId": "116796",
    //                       "createdAt": new Date().getTime(),
    //                       "originalCreatedAt": new Date().getTime(),
    //                       "refMessage": {
    //                           "referenceType": "refer",
    //                           "pageMessage": null
    //                       },
    //                       "notificationTypes": [
    //                           "push"
    //                       ]
    //                   }
    //               }
    //           ],
    //           "connectionId": "168386",
    //           "connectionPubTopic": `${process.env.REACT_APP_ECO_SYSTEM}/connection/${getLocalStorageItem(
    //             CID
    //           )}/page/${selectedItem?.pageId}/createMessage`
    //       };

    //       setTimeout(() => {
    //         socket.publishToEvent(
    //           SocketTopics.PublishPageTopics,
    //           `${process.env.REACT_APP_ECO_SYSTEM}/connection/${getLocalStorageItem(
    //             CID
    //           )}/page/${selectedItem?.pageId}/group/${"members"}`,
    //           wrapRequestPayload(newMessage4)
    //         );
    //       }, 2000);
    //       }
    //     }

    //     console.log('current message', currentMessage);
    //     if(currentMessage?.data?.body?.includes("Analyzing")) {
    //       const deleteMessage = {
    //         "header": {
    //             "accessToken": "",
    //             "connectionId": "168386",
    //             "userId": "116796",
    //             "udid": "08b55241-9e8c-42e7-9b60-d83bb8563f45"
    //         },
    //         "messages": [
    //             {
    //                 "message": {
    //                     "type": "text",
    //                     "attributes": {
    //                         "notify": false
    //                     }
    //                 },
    //                 "connectionInfo": {
    //                     "connectionMessageId": generateUUID(),
    //                     "connectionId": "168386",
    //                     "pageId": selectedItem?.pageId,
    //                     "userId": "116796",
    //                     "createdAt": new Date().getTime(),
    //                     "originalCreatedAt": currentMessage?.createdAt,
    //                     "refMessage": {
    //                         "referenceType": "remove",
    //                         "pageMessageId": currentMessage?.id,
    //                         "pageMessage": null
    //                     },
    //                     "originalPageMessageId": currentMessage?.id,
    //                     "notificationTypes": [
    //                         "push"
    //                     ]
    //                 }
    //             }
    //         ],
    //         "connectionId": "168386",
    //         "connectionPubTopic": `${process.env.REACT_APP_ECO_SYSTEM}/connection/${getLocalStorageItem(
    //           CID
    //         )}/page/${selectedItem?.pageId}/createMessage`
    //     };

    //     setTimeout(() => {
    //       socket.publishToEvent(
    //         SocketTopics.PublishPageTopics,
    //         `${process.env.REACT_APP_ECO_SYSTEM}/connection/${getLocalStorageItem(
    //           CID
    //         )}/page/${selectedItem?.pageId}/group/${"members"}`,
    //         wrapRequestPayload(deleteMessage)
    //       );
    //     }, 5000);

    //     }
    //     if(currentMessage?.data?.body?.includes("Generating BOM")) {

    //       const deleteMessage = {
    //         "header": {
    //             "accessToken": "",
    //             "connectionId": "168386",
    //             "userId": "116796",
    //             "udid": "08b55241-9e8c-42e7-9b60-d83bb8563f45"
    //         },
    //         "messages": [
    //             {
    //                 "message": {
    //                     "type": "text",
    //                     "attributes": {
    //                         "notify": false
    //                     }
    //                 },
    //                 "connectionInfo": {
    //                     "connectionMessageId": generateUUID(),
    //                     "connectionId": "168386",
    //                     "pageId": selectedItem?.pageId,
    //                     "userId": "116796",
    //                     "createdAt": new Date().getTime(),
    //                     "originalCreatedAt": currentMessage?.createdAt,
    //                     "refMessage": {
    //                         "referenceType": "remove",
    //                         "pageMessageId": currentMessage?.id,
    //                         "pageMessage": null
    //                     },
    //                     "originalPageMessageId": currentMessage?.id,
    //                     "notificationTypes": [
    //                         "push"
    //                     ]
    //                 }
    //             }
    //         ],
    //         "connectionId": "168386",
    //         "connectionPubTopic": `${process.env.REACT_APP_ECO_SYSTEM}/connection/${getLocalStorageItem(
    //           CID
    //         )}/page/${selectedItem?.pageId}/createMessage`
    //     };

    //     setTimeout(() => {
    //       socket.publishToEvent(
    //         SocketTopics.PublishPageTopics,
    //         `${process.env.REACT_APP_ECO_SYSTEM}/connection/${getLocalStorageItem(
    //           CID
    //         )}/page/${selectedItem?.pageId}/group/${"members"}`,
    //         wrapRequestPayload(deleteMessage)
    //       );
    //     }, 5000);





    //     const newMessage2 = {
    //       "header": {
    //           "accessToken": "",
    //           "connectionId": "168386",
    //           "userId": "116796",
    //           "udid": "d7f55ece-6824-4172-b82b-d19d20dd183c"
    //       },
    //       "messages": [
    //           {
    //               "message": {
    //                   "type": "media",
    //                   "attributes": {
    //                       "objectId": "108168",
    //                       "serviceId": "media-service",
    //                       "objectStatus": "active",
    //                       "objectType": "medium",
    //                       "objectExpiry": 0,
    //                       "partitions": [],
    //                       "originalName": "BOM.xlsx",
    //                       "encoding": "7bit",
    //                       "mimeType": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    //                       "info": {
    //                           "pageId": "221712",
    //                           "userId": "116796",
    //                           "location": {
    //                               "coordinates": {
    //                                   "latitude": 31.5262156,
    //                                   "longitude": 74.4176446
    //                               },
    //                               "clbs": {
    //                                   "tags": [
    //                                       "type:media",
    //                                       "org:undefined",
    //                                       "name:BOM.xlsx"
    //                                   ]
    //                               }
    //                           }
    //                       },
    //                       "urls": {
    //                           "original": {
    //                               "url": "https://media.staging.beam.live/108168_original.xlsx",
    //                               "size": 8153
    //                           }
    //                       },
    //                       "uploadedAt": "2025-10-23T15:16:19.610Z",
    //                       "location": {
    //                           "coordinates": {
    //                               "lat": 31.5262156,
    //                               "long": 74.4176446
    //                           }
    //                       },
    //                       "clientId": "60c83dcefe8cea1cd6699618",
    //                       "body": "BOM.xlsx"
    //                   }
    //               },
    //               "connectionInfo": {
    //                   "connectionMessageId": generateUUID(),
    //                   "connectionId": "168386",
    //                   "pageId": selectedItem?.pageId,
    //                   "userId": "116796",
    //                   "createdAt": new Date().getTime(),
    //                   "originalCreatedAt": new Date().getTime(),
    //                   "refMessage": {
    //                       "referenceType": "refer",
    //                       "pageMessage": null
    //                   },
    //                   "notificationTypes": [
    //                       "push"
    //                   ]
    //               }
    //           }
    //       ],
    //       "connectionId": "168386",
    //       "connectionPubTopic": `${process.env.REACT_APP_ECO_SYSTEM}/connection/${getLocalStorageItem(
    //         CID
    //       )}/page/${selectedItem?.pageId}/createMessage`
    //   };

    //   setTimeout(() => {
    //     socket.publishToEvent(
    //       SocketTopics.PublishPageTopics,
    //       `${process.env.REACT_APP_ECO_SYSTEM}/connection/${getLocalStorageItem(
    //         CID
    //       )}/page/${selectedItem?.pageId}/group/${"members"}`,
    //       wrapRequestPayload(newMessage2)
    //     );
    //   }, 6000);

    //   const newMessage3 = {
    //     "header": {
    //         "accessToken": "",
    //         "connectionId": "168386",
    //         "userId": "116796",
    //         "udid": "3a9b536f-aac9-47d8-93e1-a7c344f61e02"
    //     },
    //     "messages": [
    //         {
    //             "message": {
    //                 "type": "rsvp",
    //                 "attributes": {
    //                     "type": "threeButtons",
    //                     "options": {
    //                         "option1": "Accept",
    //                         "option2": "Hold",
    //                         "option3": "Reject"
    //                     },
    //                     "rsvpTitle": "Do you approve this BOM?",
    //                     "body": "Do you approve this BOM?"
    //                 }
    //             },
    //             "connectionInfo": {
    //                 "connectionMessageId": generateUUID(),
    //                 "connectionId": "168386",
    //                 "pageId": selectedItem?.pageId,
    //                 "userId": "116796",
    //                 "createdAt": new Date().getTime(),
    //                 "originalCreatedAt": new Date().getTime(),
    //                 "refMessage": {
    //                     "referenceType": "refer",
    //                     "pageMessage": null
    //                 },
    //                 "notificationTypes": [
    //                     "push"
    //                 ]
    //             }
    //         }
    //     ],
    //     "connectionId": "168386",
    //     "connectionPubTopic": `${process.env.REACT_APP_ECO_SYSTEM}/connection/${getLocalStorageItem(
    //       CID
    //     )}/page/${selectedItem?.pageId}/createMessage`
    // };

    // setTimeout(() => {
    //   socket.publishToEvent(
    //     SocketTopics.PublishPageTopics,
    //     `${process.env.REACT_APP_ECO_SYSTEM}/connection/${getLocalStorageItem(
    //       CID
    //     )}/page/${selectedItem?.pageId}/group/${"members"}`,
    //     wrapRequestPayload(newMessage3)
    //   );
    // }, 7000);

    //     }


    //     if(currentMessage?.data?.body?.includes("thinking")) {
    //       const deleteMessage = {
    //         "header": {
    //             "accessToken": "",
    //             "connectionId": "168386",
    //             "userId": "116796",
    //             "udid": "08b55241-9e8c-42e7-9b60-d83bb8563f45"
    //         },
    //         "messages": [
    //             {
    //                 "message": {
    //                     "type": "text",
    //                     "attributes": {
    //                         "notify": false
    //                     }
    //                 },
    //                 "connectionInfo": {
    //                     "connectionMessageId": generateUUID(),
    //                     "connectionId": "168386",
    //                     "pageId": selectedItem?.pageId,
    //                     "userId": "116796",
    //                     "createdAt": new Date().getTime(),
    //                     "originalCreatedAt": currentMessage?.createdAt,
    //                     "refMessage": {
    //                         "referenceType": "remove",
    //                         "pageMessageId": currentMessage?.id,
    //                         "pageMessage": null
    //                     },
    //                     "originalPageMessageId": currentMessage?.id,
    //                     "notificationTypes": [
    //                         "push"
    //                     ]
    //                 }
    //             }
    //         ],
    //         "connectionId": "168386",
    //         "connectionPubTopic": `${process.env.REACT_APP_ECO_SYSTEM}/connection/${getLocalStorageItem(
    //           CID
    //         )}/page/${selectedItem?.pageId}/createMessage`
    //     };

    //     setTimeout(() => {
    //       socket.publishToEvent(
    //         SocketTopics.PublishPageTopics,
    //         `${process.env.REACT_APP_ECO_SYSTEM}/connection/${getLocalStorageItem(
    //           CID
    //         )}/page/${selectedItem?.pageId}/group/${"members"}`,
    //         wrapRequestPayload(deleteMessage)
    //       );
    //     }, 2000);

    //     }
    //     if(currentMessage?.data?.body?.includes('quote')) {
    //       const message = {
    //         "header": {
    //             "accessToken": "",
    //             "connectionId": "168386",
    //             "userId": "116796",
    //             "udid": "b41fc86c-e93f-4b3e-aaa2-71b5a6bb93ce"
    //         },
    //         "messages": [
    //             {
    //                 "message": {
    //                     "type": "text",
    //                     "attributes": {
    //                         "notify": false,
    //                         "body": "thinking..."
    //                     }
    //                 },
    //                 "connectionInfo": {
    //                     "connectionMessageId": generateUUID(),
    //                     "connectionId": "168386",
    //                     "pageId": selectedItem?.pageId,
    //                     "userId": "116796",
    //                     "createdAt": new Date().getTime(),
    //                     "originalCreatedAt": new Date().getTime(),
    //                     "refMessage": {
    //                         "referenceType": "refer",
    //                         "pageMessage": null
    //                     },
    //                     "notificationTypes": [
    //                         "push"
    //                     ]
    //                 }
    //             }
    //         ],
    //         "connectionId": "168386",
    //         "connectionPubTopic": `${process.env.REACT_APP_ECO_SYSTEM}/connection/${getLocalStorageItem(
    //           CID
    //         )}/page/${selectedItem?.pageId}/createMessage`
    //     };

    //     console.log('send new message', message);


    //     setTimeout(() => {
    //       socket.publishToEvent(
    //         SocketTopics.PublishPageTopics,
    //         `${process.env.REACT_APP_ECO_SYSTEM}/connection/${getLocalStorageItem(
    //           CID
    //         )}/page/${selectedItem?.pageId}/group/${"members"}`,
    //         wrapRequestPayload(message)
    //       );
    //     }, 1000);

    //     const nextMessage = {
    //       "header": {
    //           "accessToken": "",
    //           "connectionId": "168386",
    //           "userId": "116796",
    //           "udid": "b41fc86c-e93f-4b3e-aaa2-71b5a6bb93ce"
    //       },
    //       "messages": [
    //           {
    //               "message": {
    //                   "type": "text",
    //                   "attributes": {
    //                       "notify": false,
    //                       "body": "Please upload a few photos-top, sides, and one on hand if possible"
    //                   }
    //               },
    //               "connectionInfo": {
    //                   "connectionMessageId": generateUUID(),
    //                   "connectionId": "168386",
    //                   "pageId": selectedItem?.pageId,
    //                   "userId": "116796",
    //                   "createdAt": new Date().getTime(),
    //                   "originalCreatedAt": new Date().getTime(),
    //                   "refMessage": {
    //                       "referenceType": "refer",
    //                       "pageMessage": null
    //                   },
    //                   "notificationTypes": [
    //                       "push"
    //                   ]
    //               }
    //           }
    //       ],
    //       "connectionId": "168386",
    //       "connectionPubTopic": `${process.env.REACT_APP_ECO_SYSTEM}/connection/${getLocalStorageItem(
    //         CID
    //       )}/page/${selectedItem?.pageId}/createMessage`
    //   };
    //   setTimeout(() => {
    //     socket.publishToEvent(
    //       SocketTopics.PublishPageTopics,
    //       `${process.env.REACT_APP_ECO_SYSTEM}/connection/${getLocalStorageItem(
    //         CID
    //       )}/page/${selectedItem?.pageId}/group/${"members"}`,
    //       wrapRequestPayload(nextMessage)
    //     );
    //   }, 4000);

    //     }

  }, [currentMessage]);

  useEffect(() => {
    if (hideDownScrollbar) {
      setUnreadMessageCount(0);
    }
  }, [hideDownScrollbar]);

  useEffect(() => {
    setIsLoading(true);
    if (scrollTimeout) clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(() => {
      scrollToBottom();
    }, 500);
  }, [selectedItem?.pageId]);

  useEffect(() => {
    setIsLoading(false);
  }, [NoMessageFound]);

  const prevScrollHeight = useRef(0);

  useEffect(() => {
    const list = messagesEndRef.current;
    if (isLoading) {
      if (list.scrollTop < prevScrollHeight.current) {
        list.scrollTop = list.scrollHeight - prevScrollHeight.current;
      }
    }
    prevScrollHeight.current = list.scrollHeight;
    setIsLoading(false);
    if (
      localStorage.getItem("RID") !== currentMessage?.senderId?.toString() &&
      (currentMessage || !hideDownScrollbar)
    ) {
      return;
    }
    if (scrollTimeout) clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(() => {
      scrollToBottom();
    }, 500);
    console.log("messages update", messages?.[pageId]);

    // dispatch(
    //           GET_USER_BY_ID({
    //                 userId,
    //                 callback: (resp) => {
    //                   // if (resp?.data?.workflowId) {
    //                   //   subscribeToWorkflowEvents(resp?.data?.workflowId);
    //                   // }
    //                   // console.log('response', resp);
    //                   // callback && callback(resp);
    //                   console.log('get user info', )
    //                 },
    //               })
    //             );
    const notFound = [];
    if (allUsers) {
      messages?.[pageId]?.map((m) => {
        if (
          allUsers?.findIndex((x) => {
            return x?.id === m?.senderId;
          }) === -1 &&
          m?.senderId !== ""
        ) {
          console.log("user not found", m?.senderId);
          notFound.push(m?.senderId);
        }
      });
    }
    const m = [...new Set(notFound)];
    m?.map((x) => {
      dispatch(
        GET_USER_BY_ID({
          userId: x,
          callback: (resp) => {
            console.log("user info", resp);
            if (resp?.id) {
              dispatch({
                type: APPEND_ALL_USERS,
                payload: resp,
              });
            }
          },
        })
      );
    });
  }, [messages?.[pageId]?.length, pageId]);

  // const getMessagesThrottleFunc = useCallback(
  //   throttle(
  //     3000, // 3 seconds
  //     (selectedItem, offset, limit) => {
  //       console.log(`Request allowed at ${new Date().toISOString()} with offset: ${offset}, limit: ${limit}`);
  //       // Your API call
  //       getMessage(selectedItem, offset, limit);
  //     },
  //     { atBegin: true } // Executes at the start of the interval
  //   ),
  //   []
  // );

  // const useMessageThrottledRequest = () => {
  //   const lastCallRef = useRef(0);
  //   return useCallback((selectedItem, offset, limit) => {
  //     const now = Date.now();
  //     if (now - lastCallRef.current < 2000) {
  //       console.warn("Request ignored:", { offset, limit });
  //       return; // Ignore this request
  //     }

  //     lastCallRef.current = now; // Update last call timestamp
  //     console.log("Request allowed:", { offset, limit });
  //     getMessage(selectedItem, offset, limit); // Make API call
  //   }, []);
  // };

  const useThrottledRequest = (delay = 3000) => {
    const lastCallRef = useRef(0);

    return useCallback(
      (payload) => {
        const now = Date.now();
        if (now - lastCallRef.current < delay) {
          console.warn("Request ignored:", payload);
          return; // Ignore this request
        }

        lastCallRef.current = now; // Update last call timestamp
        console.log("Request allowed:", payload);
        // getMessage(selectedItem, offset, limit); // Make API call

        dispatch({
          type: "SEARCH_MESSAGES",
          payload,
        });
      },
      [delay] // Re-create only if delay changes
    );
  };

  const getMessagethrottleFunc = useThrottledRequest(2000);

  const getMessage = (selectedItem, offset = 0, limit = 20) => {
    const requestId = generateUUID();
    localStorage.setItem("requestId", requestIds.message);

    const messageRequest: any = {
      select: {
        index: {
          searchIndex: `${process.env.REACT_APP_ECO_SYSTEM}:message:createdAt`,
          // The centre column is the page's full record and stays that way
          // whatever is filtered: the filter narrows the right-hand column
          // only. Adding a `@type` clause here would narrow the stream
          // itself, which is the behaviour we were asked to remove.
          searchQuery: `@pageId:{${selectedItem?.pageId}}`,
          searchOptions: "TIMEOUT 2000",
        },
        load: { object: "$" },
      },
      operations: [
        {
          sortBy: {
            properties: [
              SORT_FIELDS[messageSort?.primary || "newest"] ||
                SORT_FIELDS.newest,
            ],
          },
        },
      ],
      result: {
        pagination: {
          offset,
          limit,
        },
      },
      sortBy: {
        properties: [
          SORT_FIELDS[messageSort?.primary || "newest"] || SORT_FIELDS.newest,
        ],
        max: 10000,
      },
    };
    setIsLoading(true);
    socket.publishToEvent(
      SocketTopics.PublishPageTopics,
      `${process.env.REACT_APP_ECO_SYSTEM}/connection/${localStorage.getItem(
        "CID"
      )}/service/bds/aggregateBds`,
      wrapRequestPayload(messageRequest, requestIds.message)
    );
  };

  useEffect(() => {
    if (searchMessages) {
      const { limit, offset, scroll } = searchMessages;
      if (scroll) {
        // const getMessagethrottleFunc = useThrottledRequest();
        // getMessagethrottleFunc(selectedItem, offset, limit);
        getMessage(selectedItem, offset, limit);
      }
    }
  }, [searchMessages]);

  const updateStickyDate = () => {
    const dateElements = document.querySelectorAll(".date-header");
    for (let i = dateElements.length - 1; i >= 0; i--) {
      const dateElement = dateElements[i];
      const rect = dateElement.getBoundingClientRect();
      if (rect.top - 230 <= 0) {
        setStickyDate(dateElement.textContent);
        break;
      }
    }
  };
  useEffect(() => {
    const chatContainer = document.querySelectorAll(".chat-container");
    if (chatContainer && chatContainer.length) {
      const rect = chatContainer[0].getBoundingClientRect();
      document.getElementById("sticky-date").style.width =
        Math.round(rect.width) + "px";
    }

    if (stickyDate) {
      const timerId = setTimeout(() => {
        setStickyDate("");
      }, 3000);
      return () => clearTimeout(timerId);
    }
  }, [stickyDate]);

  useEffect(() => {
    if (pageConnection) {
      // TODO: move the path with proper Name to MQTTConstant file
      socket.subscribeToEvent(
        SocketTopics.SubscribePageTopics,
        `${process.env.REACT_APP_ECO_SYSTEM}/service/live/page/${selectedItem?.pageId}/group/members`
      );

      // let groupQuery = "@.group == 'members'";
      for (let group of pageConnection.groups) {
        // TODO: move the path with proper Name to MQTTConstant file
        socket.subscribeToEvent(
          SocketTopics.SubscribePageTopics,
          `${process.env.REACT_APP_ECO_SYSTEM}/service/live/page/${selectedItem?.pageId}/group/${group}`
        );
        // groupQuery+= ` || @.group == '${group}'`;
      }

      socket.subscribeToEvent(
        SocketTopics.SubscribePageTopics,
        `${process.env.REACT_APP_ECO_SYSTEM}/connection/${localStorage.getItem(
          "CID"
        )}/page/${selectedItem?.pageId}/focusMessage`
      );

      // getMessage();
      // dispatch({
      //   type: "SEARCH_MESSAGES",
      //   payload: { offset: 0, limit: 30, scroll: true, paginate: false },
      // });

      getMessagethrottleFunc({
        offset: 0,
        limit: 30,
        scroll: true,
        paginate: false,
      });
    }
  }, [pageConnection]);

  useEffect(() => {
    if (messageToSend) {
      sendMessage(
        messageToSend.message,
        messageToSend.type,
        messageToSend.data,
        undefined,
        messageToSend.edit
      );
      setPopUpDisplayed(false);
    }
  }, [messageToSend]);

  const getCurrentLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        setCurrentLocation({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        });
      });
    } else {
      console.log("Geolocation is not supported by this browser.");
    }
  };

  const updateTitle = () => {
    if (title && title !== "") {
      const payload: IMessage = getMessageRequestPayload(
        getLocalStorageItem(CID),
        getLocalStorageItem(RID),
        selectedItem?.pageId,
        getCreateMessagePublishTopic(selectedItem?.pageId),
        MessageEventType.UpdatePageTitle,
        {
          title,
        }
      );
      socket.publishToEvent(
        SocketTopics.PublishPageTopics,
        getModifyPageSubscriptionTopic(selectedItem?.pageId),
        wrapRequestPayload(payload)
      );
    }
    setEditTitle(false);
  };

  const sendPageUpdateEvent = (type, attributes) => {
    const modifyPagePayload: IMessage = getMessageRequestPayload(
      getLocalStorageItem(CID),
      getLocalStorageItem(RID),
      selectedItem?.pageId,
      "",
      type,
      attributes
    );
    socket.publishToEvent(
      SocketTopics.PublishPageTopics,
      getModifyPageSubscriptionTopic(selectedItem?.pageId),
      wrapRequestPayload(modifyPagePayload)
    );
  };

  const acceptInvitation = () => {
    sendPageUpdateEvent("acceptPageInvite", {
      userId: localStorage.getItem("RID"),
    });
    setAccepting(true);
  };

  const rejectInvitation = () => {
    sendPageUpdateEvent("rejectPageInvite", {
      userId: localStorage.getItem("RID"),
    });

    socket.publishToEvent(
      SocketTopics.PublishPageTopics,
      getMembersRemoveFromPagePublishTopic(localStorage.getItem("RID")),
      {
        pattern: getMembersRemoveFromPagePublishTopic(
          localStorage.getItem("RID")
        ),
        data: selectedItem.pageId,
      }
    );

    setRejecting(true);
  };

  useEffect(() => {
    if (fileToSend && !fileToSend.isBio) {
      setPopUpDisplayed(false);
      sendMessage(fileToSend.originalName, "media", {
        ...fileToSend,
        location: {
          coordinates: toBeamCoordinates(currentLocation),
        },
        clientId,
      });
    }
    dispatch({
      type: "ADD_FILE",
      payload: undefined,
    });
  }, [fileToSend]);

  const sendMessage = (
    message: string | undefined,
    type: string | undefined,
    data: any = undefined,
    del: any = undefined,
    ediT: any = undefined,
    pageId: number = undefined
  ) => {
    if (socket.client) {
      setMessageVisible(false);
      const editTemp = ediT ? ediT : edit;
      const messageRef: IReferenceType = {
        referenceType: (editTemp ? "update" : del ? "remove" : "refer") as any,
        pageMessageId: isReplyEnable
          ? selectedQuoteMessage.id
          : editTemp
            ? editTemp.id
            : del
              ? del.id
              : undefined,
        pageMessage: isReplyEnable ? selectedQuoteMessage : null,
      };
      if (!pageId) pageId = selectedItem?.pageId;
      const effectiveData = editTemp?.data ? editTemp.data : data;
      const userId = effectiveData?.fromAssistant ? process.env.REACT_APP_AI_ASSISTANT_USER_ID : getLocalStorageItem(RID);
      const payload: IMessage = getMessageRequestPayload(
        getLocalStorageItem(CID),
        userId,
        pageId,
        getCreateMessagePublishTopic(pageId),
        editTemp?.messageType ? editTemp.messageType : type,
        {
          ...(editTemp?.data ? editTemp.data : data),
          body: message,
        },
        editTemp
          ? editTemp.originalCreatedAt
          : del
            ? del.originalCreatedAt
            : undefined,
        messageRef,
        editTemp
          ? editTemp.originalPageMessageId
            ? editTemp.originalPageMessageId
            : editTemp.id
          : del
            ? del.originalPageMessageId
              ? del.originalPageMessageId
              : del.id
            : undefined,
        [selectedMessageType]
      );
      socket.publishToEvent(
        SocketTopics.PublishPageTopics,
        `${process.env.REACT_APP_ECO_SYSTEM}/connection/${getLocalStorageItem(
          CID
        )}/page/${pageId}/group/${"members"}`,
        wrapRequestPayload(payload)
      );

      console.log("message payload", payload);

      console.log(
        `${process.env.REACT_APP_ECO_SYSTEM}/connection/${getLocalStorageItem(
          CID
        )}/page/${pageId}/group/${"members"}`,
        wrapRequestPayload(payload));

      setText("");
      setEdit(undefined);
    }
  };

  const handleEmojiClick = (emojiObject) => {
    const updatedText = textRef.current + emojiObject.emoji;
    setText(updatedText);
    textRef.current = updatedText;
  };

  const handleMessageSend = () => {
    if (emojiToggle) setEmojiToggle(false);
    if (files?.length) uploadFiles();
    if (!text) {
      return;
    }
    const dataAttrs: Record<string, unknown> = { notify: selectedMessageType === "notify" };
    if (aiAssistEnabled && conversationId) {
      dataAttrs.conversationId = conversationId;
    }
    sendMessage(text, "text", dataAttrs);
    setIsReplyEnable(false);
  };

  const scrollToBottom = () => {
    const current = messagesEndRef.current;
    if (current) {
      current.scrollTop = messagesEndRef.current.scrollHeight;
    }

    if (timeout) clearTimeout(timeout);
    timeout = setTimeout(() => {
      const lastMessage =
        messages[selectedItem?.pageId || 0]?.[
        messages[selectedItem?.pageId || 0]?.length - 1
        ];

      if (
        parseInt(selectedItem?.lastRead?.pageMessageId ?? -1) <
        parseInt(lastMessage?.id ?? -1)
      ) {
        const payload: IMessage = getMessageRequestPayload(
          getLocalStorageItem(CID),
          getLocalStorageItem(RID),
          selectedItem?.pageId,
          getCreateMessagePublishTopic(selectedItem?.pageId),
          MessageEventType.UpdateLastRead,
          {
            userId: getLocalStorageItem(RID),
            updatedAt: new Date().getTime(),
            pageMessageId: lastMessage?.id,
          }
        );

        socket.publishToEvent(
          SocketTopics.PublishPageTopics,
          getModifyPageSubscriptionTopic(selectedItem?.pageId),
          wrapRequestPayload(payload)
        );
      }
    }, 1000);
  };

  const handleMapClick = () => {
    dispatch({ type: "SET_MAP_TYPE", payload: "PAGE" });
    dispatch({
      type: "SET_ENABLED_FILTER",
      payload: [],
    });
    dispatch({
      type: "SET_SELECTED_FILTER",
      payload: undefined,
    });
    setScreens({ ...screens, map: true });
  };

  const deleteMessage = (message: MessageObj) => {
    sendMessage(undefined, message.messageType, message.data, {
      id: message.id,
      originalCreatedAt: message.originalCreatedAt,
      originalPageMessageId: message.originalPageMessageId,
    });
  };

  const editMessage = (message: MessageObj) => {
    setEdit(message);
    setText(message.message);
  };

  const replyMessage = (message: MessageObj) => {
    setSelectedQuoteMessage(message);
    setIsReplyEnable(true);
  };

  const onForwardMessagePopupOpen = (message: MessageObj) => {
    setIsForwardMessagePopupOpen(true);
    setSelectedForwardMessage(message);
  };

  const onForwardMessageSend = (
    page: SelectedSearchItem,
    message: MessageObj
  ) => {
    sendMessage(
      message.message,
      message.messageType,
      message.data,
      false,
      false,
      page.pageId
    );
  };

  const handleVideoIconClick = () => {
    // const user = allUsers?.find(
    //   (obj) => obj.id === localStorage.getItem("RID")
    // );
    const livekitUrl = `${process.env.REACT_APP_VIDEO_URI}?pageId=${selectedItem?.pageId}&u=${localStorage.getItem("RID")}&o=${localStorage.getItem("selectedOrg") || "cudb-live"}&metadata=${localStorage.getItem("RID")}`
    window.open(
      livekitUrl,
      "_blank"
    );
    // dispatch(
    //   ENCRYPT_TOKEN({
    //     data: {
    //       payload: JSON.stringify({
    //         userId: localStorage.getItem("RID"),
    //         userBeamId: user?.beamId,
    //         connectionId: `${localStorage.getItem("CID")}`,
    //         pageId: selectedItem?.pageId,
    //         pageTitle:
    //           selectedItem?.persistent?.static?.metadata?.title ||
    //           (selectedItem?.persistent?.static?.metadata?.type === "friend" &&
    //             getFriendUserInfo(
    //               allUsers,
    //               selectedItem?.persistent?.static?.metadata?.members?.users
    //             )?.beamId
    //             ? getFriendUserInfo(
    //               allUsers,
    //               selectedItem?.persistent?.static?.metadata?.members?.users
    //             )?.beamId
    //             : `Page ${selectedItem?.pageId}`),
    //       }),
    //     },
    //     callback: (token) => {
    //       window.open(
    //         `${process.env.REACT_APP_VIDEO_URI}/room/${token.encryptedPayload}`,
    //         "_blank"
    //       );
    //     },
    //   })
    // );
  };

  const updateTyping = (typing) => {
    const payload: IMessage = getMessageRequestPayload(
      getLocalStorageItem(CID),
      getLocalStorageItem(RID),
      selectedItem?.pageId,
      getCreateMessagePublishTopic(selectedItem?.pageId),
      "updateIsTyping",
      {
        isTyping: typing,
      }
    );
    // socket.publishToEvent(
    //   SocketTopics.PublishPageTopics,
    //   getModifyPageSubscriptionTopic(selectedItem?.pageId),
    //   wrapRequestPayload(payload)
    // );
  };

  const onKeyDown = () => {
    if (typingTimeout) return;
    updateTyping(true);
    typingTimeout = setTimeout(() => {
      typingTimeout = undefined;
      updateTyping(false);
    }, 1000);
  };

  useEffect(() => {
    if (saveRecordingNotification) {
      setConfirmationDialog(true);
    }
  }, [saveRecordingNotification]);

  useEffect(() => {
    setAccepting(false);
    setRejecting(false);
  }, [memberActive]);

  const handleSaveVideo = () => {
    const userId = localStorage.getItem("RID");
    const page: any = saveRecordingNotification?.page;
    socket.publishToEvent(
      SocketTopics.PublishPageTopics,
      getTwilioSaveVideoRecordingPublishTopic(),
      {
        pageId: page?.id,
        userId,
        roomId: page?.videoRoomId,
        save: true,
      }
    );
    setConfirmationDialog(false);
    dispatch({ type: "RESET_STATE" });
  };
  const handleCancelRecording = () => {
    setConfirmationDialog(false);
    dispatch({ type: "RESET_STATE" });
  };

  let prevDate = null;
  const MessageItems = useMemo(() => {
    return (
      <React.Fragment>
        <div className="chat-container">
          {isForwardMessagePopupOpen && (
            <ForwardMessagePopup
              onSend={onForwardMessageSend}
              socket={socket}
              allUsers={allUsers}
              message={selectedForwardMessage}
              onClose={() => setIsForwardMessagePopupOpen(false)}
            ></ForwardMessagePopup>
          )}
          {isLoading && (
            <div id="message-loading">
              <Spin className="mt-5" tip="Loading">
                <div className="content" />
              </Spin>
            </div>
          )}
          <div id="scroll-down-dv">
            {!hideDownScrollbar && (
              <div className="pboYv">
                <span>
                  <div
                    onClick={scrollToBottom}
                    role="button"
                    aria-label="Scroll to bottom"
                    className="btn-scrl _25zh0"
                    data-tab="7"
                  >
                    {unreadMessageCount > 0 && (
                      <span className="SruXD">
                        <span
                          className="unread-lbl"
                          aria-label="1 unread message"
                        >
                          {unreadMessageCount}
                        </span>
                      </span>
                    )}
                    <span data-icon="down" className="_28HTg">
                      <DownOutlined />
                    </span>
                  </div>
                </span>
              </div>
            )}
          </div>
          <div id="sticky-date">
            {stickyDate && <div className="sticky-date">{stickyDate}</div>}
          </div>
          {messages?.[pageId]?.map((message: MessageObj, index) => {
            const currentDate = new Date(
              message.originalCreatedAt || message.createdAt
            ).toDateString();
            const showDateSeparator = currentDate !== prevDate;
            prevDate = currentDate;
            return (
              <div key={`${message.id}-${index}`} className="message-group">
                {showDateSeparator && (
                  <div className="date-separator mb-2">
                    <div id={index} className="date-header">
                      {formatDate(currentDate)}
                    </div>
                  </div>
                )}
                <MessageItem
                  key={index}
                  screens={screens}
                  setScreens={setScreens}
                  socket={socket}
                  onMessageVisible={() => { }}
                  onEdit={editMessage}
                  onForwardMessagePopupOpen={onForwardMessagePopupOpen}
                  onReply={replyMessage}
                  readBy={readBy}
                  onRemove={deleteMessage}
                  message={message}
                  page={selectedItem}
                  onEvent={(event, mode?: any) => {
                    setSelectedMessage(message);
                    switch (event) {
                      case "event":
                        setEventModalOpen({ visible: true, mode });
                        break;
                      case "alert":
                        setAlertModalOpen(true);
                        break;
                      case "pay":
                        setPayModalOpen({ visible: true, mode });
                        break;
                      case "rx":
                        const user = allUsers?.find(
                          (obj) => obj.id === localStorage.getItem("RID")
                        );
                        dispatch(
                          ENCRYPT_TOKEN({
                            data: {
                              payload: JSON.stringify({
                                userId: localStorage.getItem("RID"),
                                userBeamId: user?.beamId,
                                connectionId: `${localStorage.getItem("CID")}`,
                                pageId: selectedItem?.pageId,
                                pageTitle:
                                  selectedItem?.persistent?.static?.metadata
                                    ?.title ||
                                  (selectedItem?.persistent?.static?.metadata
                                    ?.type === "friend" &&
                                    getFriendUserInfo(
                                      allUsers,
                                      selectedItem?.persistent?.static?.metadata
                                        ?.members?.users
                                    )
                                    ? getFriendUserInfo(
                                      allUsers,
                                      selectedItem?.persistent?.static
                                        ?.metadata?.members?.users
                                    )
                                    : `Page ${selectedItem?.pageId}`),
                              }),
                            },
                            callback: (token) => {
                              console.log("message data", message);
                              const topic = message.data.iotTopic?.split("/");

                              window.open(
                                `${process.env.REACT_APP_SHARED_URI
                                }/rx?videoToken=${token.encryptedPayload
                                }&userId=${topic?.[4]}&iotUserId=${message.data.iotUserId
                                }&iotUdid=${message.data.iotUdid
                                }&connectionId=${localStorage.getItem("RID")}`,
                                "_blank"
                              );
                            },
                          })
                        );
                    }
                  }}
                />
              </div>
            );
          })}
        </div>
      </React.Fragment>
    );
  }, [
    JSON.stringify(messages?.[pageId]),
    pageId,
    selectedItem,
    stickyDate,
    unreadMessageCount,
    hideDownScrollbar,
    isForwardMessagePopupOpen,
    selectedForwardMessage,
    isLoading,
  ]);

  const handleFileChange = (e) => {
    const fileList = e.target.files;
    const filesArray = Array.from(fileList);
    addFilesToList(filesArray);
  };
  const addFilesToList = (filesArray) => {
    filesArray.forEach((file: any) => {
      const reader = new FileReader();
      reader.onload = (event) => {
        let fileName = file.name.split(".");
        let ext = fileName[fileName.length - 1];
        let preview =
          ext !== "png" && ext !== "jpg" && ext !== "jpeg"
            ? `/images/files-icon/${ext + ".png"}`
            : event.target.result;
        let size = formatFileSize(file.size);
        const fileObject = {
          name: file.name,
          size: size,
          ext: ext.toUpperCase(),
          file: file,
          preview: preview,
        };
        setFiles((prevFiles) => {
          if (!Array.isArray(prevFiles)) {
            prevFiles = [];
          }
          return [...prevFiles, fileObject];
        });
      };
      reader.readAsDataURL(file);
    });
  };
  const handleRemoveFile = (index) => {
    setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  useEffect(() => {
    let dropTarget = document.getElementById("dropTarget");
    let currentHeight = document
      .querySelector("#dropTarget")
      .getBoundingClientRect().height;
    let scrollDownBtnEle = document.getElementById("scroll-down-dv");

    let height = 136;
    if (dropTarget && files && files.length && !isFilePreviewOpen) {
      dropTarget.style.height = currentHeight - height + "px";
      if (scrollDownBtnEle) scrollDownBtnEle.style.bottom = "253px";
      setIsFilePreviewOpen(true);
    } else if (isFilePreviewOpen && (!files || !files.length)) {
      setIsFilePreviewOpen(false);
      dropTarget.style.height = currentHeight + height + "px";
      if (scrollDownBtnEle) scrollDownBtnEle.style.bottom = "117px";
    }
  }, [files?.length]);

  useEffect(() => {
    getCurrentLocation();
  }, []);

  return (
    <div className="main-column message-panel mr-4">
      <div className="main-content">
        <div className="main-header">
          <div className="d-flex">
            {selectedItem?.persistent?.static?.metadata?.type !== "friend" ? (
              <ReactSVG
                src={getAvatar(selectedItem)}
                className="colorable mark-icon"
              />
            ) : (
              <img
                src={
                  getFriendUserInfo(
                    allUsers,
                    selectedItem?.persistent?.static?.metadata?.members?.users
                  )?.profileImage ?? "/images/users/user.png"
                }
                className="user-avatar"
                style={{ borderRadius: "50%" }}
                width={42}
                height={42}
                alt=""
              />
            )}
            {!editTitle ? (
              <React.Fragment>
                <h3 className="ml-3" style={{ color }}>
                  {selectedItem?.persistent?.static?.metadata?.title ||
                    (selectedItem?.persistent?.static?.metadata?.type ===
                      "friend" &&
                      getFriendUserInfo(
                        allUsers,
                        selectedItem?.persistent?.static?.metadata?.members?.users
                      )?.beamId
                      ? getFriendUserInfo(
                        allUsers,
                        selectedItem?.persistent?.static?.metadata?.members
                          ?.users
                      )?.beamId
                      : `Page ${selectedItem?.pageId || ""}`)}
                </h3>
                {selectedItem?.persistent?.static?.metadata?.type !==
                  "friend" && (
                    <ReactSVG
                      className="ml-3 sz-18"
                      src="/images/edit-icon.svg"
                      onClick={() => {
                        setEditTitle(true);
                      }}
                    />
                  )}
              </React.Fragment>
            ) : (
              <React.Fragment>
                <Input
                  className="ml-3"
                  value={title}
                  onChange={(e: any) => setTitle(e.target.value)}
                  onKeyUp={(e: any) => {
                    if (e.key === "Enter" || e.keyCode === 13) {
                      updateTitle();
                    }
                  }}
                />
                <ReactSVG
                  className="ml-3 close-icon"
                  src="/images/close-icon.svg"
                  onClick={() => {
                    setEditTitle(false);
                  }}
                />
              </React.Fragment>
            )}
          </div>
          <div className="d-flex">
            <ReactSVG
              src="/images/expand-icon.svg"
              className="close-icon mr-4"
              onClick={() =>
                setScreens({
                  ...screens,
                  active: screens.active ? "" : "message",
                })
              }
            />
            {!isMobileScreen && (
              <ReactSVG
                src="/images/close-icon.svg"
                className="close-icon"
                onClick={() => setScreens({ ...screens, message: false })}
              />
            )}
          </div>
        </div>
        <div className="search-bar mt-3">
          <div className="d-flex">
            <Input
              className="beam-input"
              placeholder="Search..."
              suffix={<SearchOutlined />}
            />
            <Button className="beam-btn ml-2" onClick={() => { }}>
              <SettingsIcon />
            </Button>
            <Button
              className="beam-btn ml-2"
              onClick={() => setFilterPopUpDisplayed(true)}
            >
              <FilterIcon />
            </Button>

            <Button className="beam-btn ml-2" onClick={handleMapClick}>
              <CompassIcon />
            </Button>
          </div>
        </div>

        <div
          ref={messagesEndRef}
          className="main-cards"
          id="dropTarget"
          onScroll={(e: any) => {
            const top = e.target.scrollTop === 0;
            setHideDownScrollbar(isScrollbarAtBottom(e.target));
            if (top && messages?.[pageId]?.[0]?.id && !isLoading) {
              // setIsLoading(true);
              // dispatch({
              //   type: "SEARCH_MESSAGES",
              //   payload: {
              //     offset: searchMessages.offset + searchMessages.limit,
              //     paginate: true,
              //   },
              // });
              getMessagethrottleFunc({
                offset: searchMessages.offset + searchMessages.limit,
                paginate: true,
              });
            }
            updateStickyDate();
          }}
        >
          <div className="dropper">
            <p>Drop media to upload</p>
          </div>

          {/*
            The centre column always keeps the chat/message result. Filtering
            narrows which messages the query returns, but it no longer swaps the
            stream for a ledger view — those render in the right-hand column now.
          */}
          {messages[pageId || 0] && memberActive && (
            <React.Fragment>{MessageItems}</React.Fragment>
          )}
          {pageId && !memberActive && (
            <div className="d-block align-items-center invite-container">
              <h3 className="font-weight-bold">
                {selectedItem?.persistent.static.metadata?.members?.users?.[
                  localStorage.getItem("RID")
                ]?.pending?.invitedBy ?? "Beamer"}
              </h3>
              <h4>has invited you to this page</h4>
              <Row className="action-grp mt-4 w-full">
                <Col span={12} className="pr-2">
                  <Button
                    className="beam-btn green-btn cover w-full"
                    loading={accepting}
                    onClick={() => {
                      acceptInvitation();
                    }}
                  >
                    Accept
                  </Button>
                </Col>
                <Col span={12} className="pr-2">
                  <Button
                    loading={rejecting}
                    className="beam-btn orange-btn bordered w-full"
                    onClick={() => {
                      rejectInvitation();
                    }}
                  >
                    Decline
                  </Button>
                </Col>
              </Row>
            </div>
          )}
        </div>

        {selectedItem &&
          (selectedItem?.currentUserRole === "edit" ||
            selectedItem?.currentUserRole === "write") &&
          selectedItem?.memberActive && (
            <div className="main-footer">
              {aiAssistThinking && (
                <div className="message-opposite-user-status">
                  <label>Thinking...</label>
                  <Loader type="ThreeDots" color="#91A5C6" height={10} width={10} />
                </div>
              )}
              {!aiAssistThinking && typing && typing !== "" && (
                <MessageOppositeUserStatus user={typing} />
              )}
              <div className="d-flex">
                <div className="mr-1" style={{ width: "45px" }}>
                  {
                    <Button className="beam-btn" onClick={openPopupModal}>
                      <PlusOutlined />
                    </Button>
                  }
                </div>
                <div style={{ width: "-webkit-fill-available" }}>
                  <div className="files-preview-main">
                    <div style={{ position: "absolute", bottom: "50px" }}>
                      {emojiToggle && (
                        <EmojiPicker
                          className="col-md-12"
                          onEmojiClick={handleEmojiClick}
                        />
                      )}
                    </div>
                    <div id="preview-dv" className="col-md-12 preview-dv">
                      {files?.length > 0 &&
                        files.map((file, index) => (
                          <div
                            className="mr-2 mt-1 pt-1 pb-0 preview-cover"
                            key={index}
                          >
                            <div>
                              <img
                                onError={handleImageError}
                                className="pt-2 preview-img"
                                src={file.preview}
                                alt="Preview"
                              />
                            </div>
                            <div className="pr-1 pl-1">
                              <div>
                                <span>
                                  <small>
                                    {" "}
                                    {truncateString(file.name, 15)}
                                  </small>
                                </span>
                              </div>
                              <div>
                                <span>
                                  <small>{file.size}</small> |{" "}
                                  <small>{file.ext}</small>
                                </span>
                              </div>
                            </div>
                            {uploadProgress && uploadProgress[file.name] && (
                              <span className="text-center progress-bar mr-1 w-full">
                                {uploadProgress[file.name] || 0}%
                              </span>
                            )}
                            <Button
                              color="black"
                              size="small"
                              className="btn-close"
                              icon={
                                <CloseCircleOutlined className="pull-right" />
                              }
                              onClick={() => handleRemoveFile(index)}
                            ></Button>
                          </div>
                        ))}
                    </div>
                    {isReplyEnable && (
                      <QuoteMessage
                        onCancel={() => setIsReplyEnable(false)}
                        showCancelButton={true}
                        message={selectedQuoteMessage}
                      />
                    )}
                    <div>
                      <div className="emoji-dv">
                        <SmileOutlined
                          onClick={handleToggleClick}
                          className="mt-3 ml-2 btn-emoji"
                        />
                      </div>
                      <div className="txt-area-dv">
                        <TextArea
                          className="m-0 remove-focus chat-input"
                          onKeyDown={onKeyDown}
                          value={text}
                          autoSize={{ minRows: 1, maxRows: 6 }}
                          onFocus={() => setIsInputFocused(true)}
                          onBlur={() => setIsInputFocused(false)}
                          onChange={(e) => {
                            setText(e.target.value);
                            textRef.current = e.target.value;
                          }}
                          onKeyPress={(e) => {
                            if (e.key === "Enter") {
                              if (e.shiftKey) {
                              } else {
                                e.preventDefault();
                                handleMessageSend();
                              }
                            }
                          }}
                          placeholder="Type a message..."
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div style={{ minWidth: "90px" }} className="pr-0 mb-2 ml-1">
                  <input
                    multiple
                    id="file-upload"
                    type="file"
                    hidden
                    onChange={handleFileChange}
                  />
                  {text || files?.length ? (
                    <Button
                      className="mr-1 beam-btn ml-1"
                      onClick={handleMessageSend}
                    >
                      <SendOutlined />
                    </Button>
                  ) : (
                    <React.Fragment>
                      {showVideo &&
                        <Button
                          className="mr-1 beam-btn ml-1"
                          onClick={handleVideoIconClick}
                        >
                          <VideoCameraOutlined />
                        </Button>
                      }
                    </React.Fragment>
                  )}
                  {!text && (
                    <Button
                      className="beam-btn"
                      onClick={() => {
                        // document.getElementById("file-upload").click()
                        setUploadPopUpDisplayed(true);
                      }
                      }
                    >
                      <UploadOutlined />
                    </Button>
                  )}
                </div>
              </div>
              <div className="mt-2 min-h">
                {(text || isInputFocused) && (
                  <div onMouseDown={(e) => e.preventDefault()}>
                    {selectedMessageType === "snap" && (
                      <Col span={24} className="datetime-item mt-1 mb-1">
                        <img src="/images/time.png" />
                        <TimePicker
                          placeholder="Enter time in secs"
                          suffixIcon={<DownOutlined />}
                        />
                      </Col>
                    )}

                    <Row className="d-flex">
                      <Col className="text-right" span={3}>
                        <Button
                          size="small"
                          onClick={() => {
                            setSelectedMessageType("ai-assist");
                            setAiAssistEnabled(true);
                            setConversationId(generateUUID());
                          }}
                          className={`type-button${selectedMessageType === "ai-assist"
                            ? " type-selected"
                            : ""
                            }`}
                        >
                          AI Assist
                        </Button>
                      </Col>
                      <Col className="text-right" span={3}>
                        <Button
                          size="small"
                          onClick={() => {
                            setSelectedMessageType("push");
                            setAiAssistEnabled(false);
                            setConversationId(null);
                          }}
                          className={`type-button${selectedMessageType === "push"
                            ? " type-selected"
                            : ""
                            }`}
                        >
                          Text
                        </Button>
                      </Col>
                      <Col className="text-right" span={3}>
                        <Button
                          size="small"
                          onClick={() => {
                            setSelectedMessageType("notify");
                            setAiAssistEnabled(false);
                            setConversationId(null);
                          }}
                          className={`type-button${selectedMessageType === "notify"
                            ? " type-selected"
                            : ""
                            }`}
                        >
                          Notify
                        </Button>
                      </Col>

                      <Col className="text-right" span={3}>
                        <Button
                          size="small"
                          onClick={() => {
                            setSelectedMessageType("email");
                            setAiAssistEnabled(false);
                            setConversationId(null);
                          }}
                          className={`type-button${selectedMessageType === "email"
                            ? " type-selected"
                            : ""
                            }`}
                        >
                          Email
                        </Button>
                      </Col>

                      <Col className="text-right" span={3}>
                        <Button
                          size="small"
                          onClick={() => {
                            setSelectedMessageType("sms");
                            setAiAssistEnabled(false);
                            setConversationId(null);
                          }}
                          className={`type-button${selectedMessageType === "sms"
                            ? " type-selected"
                            : ""
                            }`}
                        >
                          SMS
                        </Button>
                      </Col>

                      {pageGroups.map((groupName, idx) => (
                        <React.Fragment>
                          <Col key={idx} className="text-right" span={4}>
                            <Button
                              className={`type-button${selectedMessageType === groupName
                                ? " type-selected"
                                : ""
                                }`}
                              onClick={() => {
                                setSelectedMessageType(groupName);
                                setAiAssistEnabled(false);
                                setConversationId(null);
                              }}
                            >
                              {groupName}
                            </Button>
                          </Col>
                        </React.Fragment>
                      ))}
                    </Row>
                  </div>
                )}
              </div>
            </div>
          )}
      </div>
      {popupDisplayed && (
        <PopupModal
          socket={socket}
          type="MESSAGE"
          onClose={() => setPopUpDisplayed(false)}
        />
      )}
      {filterPopupDisplayed && (
        <PopupModal
          type="FILTER"
          onClose={() => setFilterPopUpDisplayed(false)}
        />
      )}

      {uploadPopupDisplayed && (
        <PopupModal
          type="UPLOAD"
          onClose={() => setUploadPopUpDisplayed(false)}
          onClick={(type) => {
            document.getElementById("file-upload").click()
          }}
        />
      )}

      {settingsModalDisplayed && (
        <PageSettingsModal onClose={() => setSettingsModalDisplayed(false)} />
      )}
      {peoplePopupDisplayed && (
        <PeopleModal
          socket={socket}
          onClose={() => setPeoplePopupDisplayed(false)}
        />
      )}
      {confirmationDialog && (
        <ConfirmationModal
          handleConfirm={handleSaveVideo}
          message={"Archive video?"}
          onClose={handleCancelRecording}
          okMessage={"Yes"}
          cancelMessage={"No"}
        />
      )}
      {eventModalOpen?.visible && (
        <AddEventModal
          onClose={() => setEventModalOpen({ visible: false })}
          eventObj={selectedMessage?.data}
          mode={eventModalOpen?.mode}
          id={`${selectedMessage?.id}${localStorage.getItem("RID")}`}
          socket={socket}
          message={selectedMessage}
        />
      )}

      {payModalOpen?.visible && (
        <AddPayModal
          onClose={() => setPayModalOpen({ visible: false })}
          eventObj={selectedMessage?.data}
          mode={payModalOpen?.mode}
          id={`${selectedMessage?.id}${localStorage.getItem("RID")}`}
          socket={socket}
          message={selectedMessage}
        />
      )}

      {alertModalOpen && (
        <IoTAlertModal
          onClose={() => setAlertModalOpen(false)}
          alertObj={selectedMessage?.data}
        />
      )}
    </div>
  );
};

export default MessagePanel;
